import { URL_PATTERN } from '../../app/core/constants'
/**
 * AddDeviceRedirectCtrl controller
 * Add/Edit Extensions
 */

/**
* AddDeviceRedirectCtrl controller
*
* @class AddDeviceRedirectCtrl
* @memberof mwApp/settings
* @see mwApp/settings
*
* @ngdoc controller
* @name mwApp/settings.controller:AddDeviceRedirectCtrl
*/

/* @ngInject */

export default function AddDeviceRedirectCtrl ($uibModalInstance, redirect) {
  var vm = this

  vm.urlPattern = URL_PATTERN

  /**
   * Device Redirect Extension
   *
   * @memberof mwApp/settings.controller:AddDeviceRedirectCtrl
   * @type {models.Extension}
   */
  vm.redirect = redirect

  /**
   * isNew flag
   *
   * @memberof mwApp/settings.controller:AddDeviceRedirectCtrl
   * @type {Boolean}
   */
  vm.isNew = redirect._isNew()

  /**
   * Create or edit Device Redirect extension, and close modal window afterwards
   *
   * @memberof mwApp/settings.controller:AddDeviceRedirectCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    redirect._save()
      .then(
        () => $uibModalInstance.close(redirect)
      )
      .finally(vm.unsetDisable)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/settings.controller:AddDeviceRedirectCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
